import { LANDING_PAGE_CONFIG } from '../config/landingPageConfig';
import { ROUTE } from '../route/RouteEnums';

export const getLandingPageOptions = (permissions: string[]) => {
  if (!permissions) return [];

  const options: { label: string; route: string }[] = [];

  permissions.forEach(permission => {
    const config = LANDING_PAGE_CONFIG[permission];
    if (config) {
      options.push(...config);
    }
  });

  return options;
};

export const getDefaultLandingPage = () => {
  const userStr = sessionStorage.getItem('user');

  if (!userStr) return ROUTE.ADMIN_DASHBOARD;

  try {
    const user = JSON.parse(userStr);

    // patient
    if (!user?.isAdmin) {
      return '/dashboard';
    }
    console.log('user?.defaultLandingRoute', user?.defaultLandingRoute);
    // admin roles
    return user?.defaultLandingRoute || ROUTE.ADMIN_DASHBOARD;
  } catch {
    return ROUTE.ADMIN_DASHBOARD;
  }
};